module.exports = __webpack_public_path__ + "img/vertical_4_5_1.420455c8.png";